export default __webpack_public_path__ + "static/media/checkbox_selected.cacc47c1.svg";